import { html } from "lit";
import { customElement, state, property } from "lit/decorators.js";
import { BaseElement } from "../BaseElement";
import { style } from "./ContributorStats.style";
import { litIf } from "../LitUtils";

type BaseStatistics = {
    total: number;
    created: number;
    updated: number;
    deleted: number;
};

type UserProperties = {
    name: string;
    id: string;
};

type UserStatistics = BaseStatistics & UserProperties;

type WeeklyStatisticsProperties = {
    key: string;
};

type UsersMixin = {
    users: UserStatistics[];
};

type WeeklyStatistics = BaseStatistics & WeeklyStatisticsProperties & UsersMixin;
type GlobalStatistics = BaseStatistics & UsersMixin;

type Statistics = {
    global: GlobalStatistics;
    weekly: WeeklyStatistics[];
};

@customElement("ds-contributor-stats")
export class ContributorStats extends BaseElement {
    static override styles = [style];

    @property({ type: String }) url = "https://app.cavedb.net/contribution_stats.json";
    @state() protected _stats: Statistics | undefined;

    protected override async firstUpdated(): Promise<void> {
        if (this.url) {
            try {
                const response = await window.fetch(this.url, { cache: "default" });
                if (response.status === 200) {
                    this._stats = await response.json();
                }
            } catch {
                // no-op
            }
        }
    }

    private _renderTopContributors(
        title: string,
        numToShow: number,
        stats: UserStatistics[] | undefined
    ) {
        if (!stats) {
            return html``;
        }
        return html` <h3>${title}</h3>
            <div class="flex-column">
                ${stats.slice(0, numToShow).map(
                    (x) =>
                        html`<div class="flex-column">
                                <ds-profile-badge
                                    .user=${x.id}
                                    .detailText=${`${x.total} changes with ${x.updated} edits and ${x.created}
                                        adds`}
                                ></ds-profile-badge>
                            </div>
                            <hr /> `
                )}
            </div>`;
    }

    override render() {
        return html`${litIf(
            this._stats && this._stats.weekly && this._stats.weekly.length > 0,
            () =>
                html`${this._renderTopContributors(
                    `This week`,
                    10,
                    this._stats?.weekly[this._stats?.weekly.length - 1].users
                )}${this._renderTopContributors(
                    `All time contributors`,
                    10,
                    this._stats?.global.users
                )} `
        )}`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-contributor-stats": ContributorStats;
    }
}
